import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const InputSection = ({ title, icon, data, onChange, color }) => {
  const colorClasses = {
    primary: {
      bg: 'bg-primary-50',
      border: 'border-primary-200',
      icon: 'text-primary-600',
      focus: 'focus:border-primary-500 focus:ring-primary-500'
    },
    success: {
      bg: 'bg-success-50',
      border: 'border-success-200',
      icon: 'text-success-600',
      focus: 'focus:border-success-500 focus:ring-success-500'
    }
  };

  const colors = colorClasses[color];

  const handleChange = (field, value) => {
    onChange({
      ...data,
      [field]: parseFloat(value) || 0
    });
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`${colors.bg} ${colors.border} border-2 rounded-2xl p-8 shadow-lg`}
    >
      <div className="flex items-center gap-3 mb-6">
        <SafeIcon icon={icon} className={`text-2xl ${colors.icon}`} />
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
      </div>

      <div className="space-y-6">
        {/* Loan Amount */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Loan Amount
          </label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium">
              $
            </span>
            <input
              type="number"
              value={data.amount}
              onChange={(e) => handleChange('amount', e.target.value)}
              className={`w-full pl-8 pr-4 py-3 border-2 border-gray-200 rounded-xl ${colors.focus} transition-colors text-lg font-medium`}
              placeholder="350,000"
            />
          </div>
          <p className="mt-1 text-sm text-gray-500">
            {formatCurrency(data.amount)}
          </p>
        </div>

        {/* Interest Rate */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Interest Rate
          </label>
          <div className="relative">
            <input
              type="number"
              step="0.01"
              value={data.rate}
              onChange={(e) => handleChange('rate', e.target.value)}
              className={`w-full pr-8 pl-4 py-3 border-2 border-gray-200 rounded-xl ${colors.focus} transition-colors text-lg font-medium`}
              placeholder="6.50"
            />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium">
              %
            </span>
          </div>
        </div>

        {/* Term */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Loan Term
          </label>
          <div className="relative">
            <input
              type="number"
              value={data.term}
              onChange={(e) => handleChange('term', e.target.value)}
              className={`w-full pr-12 pl-4 py-3 border-2 border-gray-200 rounded-xl ${colors.focus} transition-colors text-lg font-medium`}
              placeholder="30"
            />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium">
              years
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default InputSection;